import {Component, OnInit} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.css']
})
export class TextFieldComponent extends FieldComponentAbstract implements OnInit {

  ngOnInit(): void {
    this.completed = this.fieldValue.string_value != null && this.fieldValue.string_value !== '';
  }

  handleChange(value: string) {
    this.fieldValue.string_value = value;
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/text-field/text-field.component.ts